export enum GraphQlErrorType {
  AccountSuspended = 'AccountSuspended',
  BetOfferExpired = 'BetOfferExpired',
  InsufficientFunds = 'InsufficientFunds',
  MaxWagerExceeded = 'MaxWagerExceeded',
  RelatedContingency = 'RelatedContingency',
  BetTypeUnacceptable = 'BetTypeUnacceptable',
  MaxStakeExceeded = 'MaxStakeExceeded',
  MaxAllowedStake = 'MaxAllowedStake',
  MinWagerNotMet = 'MinWagerNotMet',
  PriceChange = 'PriceChange',
  EntitySuspended = 'EntitySuspended',
  MaxPotentialPayoutExceeded = 'MaxPotentialPayoutExceeded',
  Default = 'Default'
}

export const errorMap = {
  'betErrors.insufficientFunds': GraphQlErrorType.InsufficientFunds,
  'betErrors.accountSuspended': GraphQlErrorType.AccountSuspended,
  'betErrors.offerExpired': GraphQlErrorType.BetOfferExpired,
  'betErrors.betDeclined': GraphQlErrorType.MaxWagerExceeded,
  'betErrors.selectionRelated': GraphQlErrorType.RelatedContingency,
  'betErrors.betTypeNotAvailable': GraphQlErrorType.BetTypeUnacceptable,
  'betErrors.maxStakeExceeded': GraphQlErrorType.MaxStakeExceeded,
  'betErrors.minStakeExceeded': GraphQlErrorType.MinWagerNotMet,
  'betErrors.maxAllowedStake': GraphQlErrorType.MaxAllowedStake,
  'betErrors.maxPotentialPayoutExceeded': GraphQlErrorType.MaxPotentialPayoutExceeded
};

export const suspensionCodes = [
  'betErrors.eventSuspended',
  'betErrors.marketSuspended',
  'betErrors.selectionSuspended'
];

export const priceChangeCodes = ['betErrors.oddsIncreased', 'betErrors.oddsDecreased', 'betErrors.lineChanged'];

export const maxPayoutCodes = ['betErrors.maxPotentialPayoutExceeded'];

export default (error: any): GraphQlErrorType => {
  if (isMaxPayoutError(error)) {
    return GraphQlErrorType.MaxPotentialPayoutExceeded;
  }

  /**
   * This error will only be returned on POS since it allows for payouts greater than $9,999.99 but less than $2,000,000.00
   */
  if (isMaxAllowedStakeError(error)) {
    return GraphQlErrorType.MaxAllowedStake;
  }

  const code = error.exception.details[0].code;

  if (suspensionCodes.includes(code)) {
    return GraphQlErrorType.EntitySuspended;
  }

  if (priceChangeCodes.includes(code)) {
    return GraphQlErrorType.PriceChange;
  }

  if (errorMap[code]) {
    return errorMap[code];
  }

  return GraphQlErrorType.Default;
};

const isMaxAllowedStakeError = (error: any) =>
  error.exception.details.some(
    // eslint-disable-next-line no-prototype-builtins
    detail => detail.code === 'betErrors.generic' && detail?.details?.hasOwnProperty('maximum-allowed-stake')
  );

const isMaxPayoutError = (error: any) =>
  isSameItems(
    maxPayoutCodes,
    error.exception.details.map((d: any) => d.code)
  );

const isSameItems = (lhs: any, rhs: any) => rhs.some((v: any) => lhs.includes(v));
